<template>
  <l-rectangle
    :bounds="square.points"
    :key="square.id"
    :fillColor="averageIntensity(square.points)"
    :weight="0"
    :fillOpacity="0.5"
  >
    <l-tooltip :options="tooltipOptions"
      >{{ $t("message.common.yourPosition") }}: {{ visibilityLevel }}</l-tooltip
    >
  </l-rectangle>
</template>

<script>
import { LRectangle, LTooltip } from "vue2-leaflet";
import { getVisibilityLevelData, HEAT_COLOR } from "@/config/visibility_level";

export default {
  name: "MapCompetitionlayer",
  components: {
    LRectangle,
    LTooltip
  },
  props: {
    square: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      squareIntensity: null,
      tooltipOptions: {
        sticky: true,
        direction: "right",
        offset: [10, 40],
        className: "visibility-level-tooltip",
        opacity: 1
      }
    };
  },
  computed: {
    visibilityLevel() {
      const { label } = getVisibilityLevelData(this.squareIntensity);
      return label;
    }
  },
  methods: {
    averageIntensity(square) {
      const squareIntensity = square
        .map(point => {
          return point[2];
        })
        .reduce((total, current, index, array) => {
          total += current;
          if (index === array.length - 1) {
            return total / array.length;
          }
          return total;
        }, 0)
        .toFixed(2);

      this.squareIntensity = parseFloat(squareIntensity);

      return getVisibilityLevelData(this.squareIntensity).color;
    }
  }
};
</script>

<style lang="scss">
.leaflet-tooltip.visibility-level-tooltip {
  font-family: $font-family-base;
  @include font-size(14px);
  line-height: 17px;
  padding: 12px;
  background-color: rgba(127, 126, 127, 0.85);
  border: none;
  border-radius: 0;
  color: $light;
  box-shadow: none;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.2));

  &::before {
    content: unset;
  }
}
</style>
